<template>
  <div>
    <div class="container__builderall">
      <div class="container__builderall--header">
        <div 
          class="header__item header__item--active header__item--full" 
          v-text="t.team_account_my_team">
        </div>
      </div>
      <div class="container__builderall--boxed" style="padding-bottom: 6rem">
        <div class="row">
          <div class="col-md-6 flex-center">
              <h2>{{t.team_account_team}} '{{teamName}}' </h2> 
              <a 
                v-if="teamStatus != 40"
                @click="renameTeam()" 
                style="padding-left: 2rem">
              <span class="builderall-icon icon-edit"></span></a>
          </div>
            <div class="col-md-6 flex-center">
              <div style="flex-grow: 0">
                <img class="team-member" :src="team.img">
              </div>
              <div style="flex-grow: 1; padding-left: 2rem">
                <h2 class="percentage"> {{leaderComissionPercentage}}% </h2>
              </div>
              <div style="flex-grow: 1">
                <span 
                  style="font-size: 20px" 
                  v-text="team.email_lider">
                </span>
              </div>
          </div>
        </div>

        <div class="division-indicator__line"></div>
        <div class="division-indicator"> 
          <div class="progressbar">
            <div class="progressbar__label" :style="{width: leaderComissionPercentage + '%'}">{{t.team_account_my_commission}}: {{leaderComissionPercentage}}%</div>
            <div class="progressbar__label" :style="{width: totalPercent + '%'}"> <span v-html="t.team_account_rest_of_team"></span>: {{totalPercent}}%</div>
          </div>
        </div>

        <div class="table-responsive">
          <div>
            <table class="table table-team" >
              <tbody>
                <tr v-for="tu in teamUserList" :key="tu.id">
                  <td v-if="tu.status === '10'"><span class="builderall-icon icon-active"></span></td>
                  <td v-else><span class="builderall-icon icon-error"></span></td>
                  <td><img class="team-member" :src="tu.img"></td>

                  <td> <h2 class="percentage">{{ tu.percentual | toFixed}}%</h2></td>
                  <td>{{ tu.nome }}</td>
                  <td>{{ tu.email }}</td>
                  <td>
                    <a 
                      v-if="teamStatus != 40"
                      @click="editItem(tu)">  
                      <span class="builderall-icon icon-edit"></span> 
                    </a>
                    <a 
                      v-if="teamStatus != 40"
                      @click="openModalDelete(tu)">  
                      <span class="builderall-icon icon-trash"></span> 
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {{totalMembers}} {{ t.team_account_members_with_me }}

        <div 
          class="builderall-block_info" 
          v-if="teamStatus == 15"
          v-html="t.team_account_min_members_message">
        </div>

        <div 
          class="builderall-block_error" 
          v-if="teamStatus == 40"
          v-html="t.team_account_canceled"> 
          >
        </div>

        <a 
          v-if="teamStatus != 40"
          @click="newMember()" 
          class="builderall-button--rounded">
          <span class="builderall-icon icon-add" style="padding: 0"></span>
        </a>

      </div>
    </div>


    <!-- MODAL EDIT / NEW -->
    <div class="modal fade" id="modalEditTeamMember" tabindex="-1" role="dialog" aria-labelledby="modalEditTeamMember" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content builderall-modal">
          <div class="builderall-modal__header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 
              class="builderall-modal__header--title"
              v-html="t.team_account_member_of_team">
            </h3>
          </div>
          <div class="builderall-modal__body">
            <form>
              <div class="form-group">
                <label> 
                  {{t.team_account_mail_of_participant}}:
                  <span class="field--required">*</span> 
                </label>

                <input 
                  type="email" 
                  :readonly="fieldMailReadonly" 
                  required="" 
                  v-model="editedEmail" 
                  v-bind:class="['form-control', { 'field--error': errorMail === true }]">

                <span 
                  class="field--text-error" 
                  v-if="errorMail"
                  v-html="t.email_invalid_character">
                </span>  

              </div>

              <div class="form-group">
                <label> 
                  {{t.team_account_percentage}}:
                  <span class="field--required">*</span>
                </label>

                <input 
                  type="number" 
                  step="1" 
                  v-model="editedPercentage"  
                  v-bind:class="['form-control', { 'field--error': errorPercentage === true }]">
                  <span 
                    v-if="errorPercentage" 
                    class="field--text-error" > 
                    {{t.team_account_error_percentage}} {{comissionAvailable}}%
                  </span>
              </div>
              <div class="builderall-modal__body--info">
                  {{t.team_account_your_current_commission}}: <span class="percentage"> {{leaderComissionPercentage}}% </span> <br>
                  {{t.team_account_your_new_commission}}: <span class="percentage"> {{ leaderNewPercentage }} </span>
              </div>
              <div class="builderall-modal__body--helper" v-html="t.team_account_add_member_help"></div>
            </form>
          </div>
          <div class="builderall-modal__footer center">
            <button 
              type="submit" 
              :class="['button3 extra-large', {'__loading': loading}]"
              :disabled="buttonSaveDisabled"
              @click="saveItem()" 
              v-text="t.button_salvar">
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL RENAME TEAM -->
    <div class="modal fade" id="modalRenameTeam" tabindex="-1" role="dialog" aria-labelledby="modalRenameTeam" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content builderall-modal">
          <div class="builderall-modal__header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="builderall-modal__header--title">{{t.label_renomear}} {{t.team_account_my_team}}</h3>
          </div>
          <div class="builderall-modal__body">
            <form >
              <div class="form-group">
                <label v-html="t.team_account_new_team_name"></label>
                <input type="text" :placeholder="teamName" v-model="newTeamName" v-bind:class="['form-control', { 'field--error': errorRename === true }]">
                <span 
                    class="field--text-error" 
                    v-if="errorRename" 
                    v-text="'This field is required'">
                  </span> 
              </div>
            </form>
          </div>
          <div class="builderall-modal__footer center">
            <button 
              type="submit" 
              :class="['button3 extra-large', {'__loading': buttonSaveTeamNameDisabled}]"
              @click="updateTeamName()" 
              v-text="t.button_salvar">
            </button>
          </div>
        </div>
      </div>
    </div>

     <!-- MODAL DELETE -->
    <div class="modal fade" id="modalDeleteUser" tabindex="-1" role="dialog" aria-labelledby="modalDeleteUser" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content builderall-modal">
          <div class="builderall-modal__header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h3 class="builderall-modal__header--title">{{t.general_label_delete}} {{t.team_account_member_of_team}} </h3>
          </div>
          <div class="builderall-modal__body" style="padding: 3rem 3rem 0 4rem">
            <p><b v-html="t.team_account_delete_member_confirmation"></b></p>
            <table class="table table-team" style="margin-top: 1.5rem" >
              <tbody>
                <tr>
                  <td><img class="team-member" :src="userToDelete.img"></td>
                  <td>{{userToDelete.nome }}</td>
                  <td>{{t.team_account_percentage}}: {{ userToDelete.percentual | toFixed}}%</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="builderall-modal__footer center">
            <button 
              type="submit" 
              :class="['button3 extra-large', {'__loading': loading}]" 
              :disabled="buttonSaveDisabled" 
              @click="deleteItem()"
              v-text="t.general_label_delete">
            </button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>

export default {
  name: "team-account-management",
  props: ["handler_routes","team","team_users","translations"],

  data() {
    return {
      teamUserList: [],
      userToDelete: [],
      t: [], //translations
      errorPercentage: false,
      errorMail: false,
      teamStatus: 0,
      teamName: '',
      newTeamName: '',

      totalDistributedPercentage: 0,
      leaderNewPercentage: 0,
      comissionAvailable: 0,

      fieldMailReadonly: false,
      buttonSaveDisabled: false,
      buttonSaveTeamNameDisabled: false,
      loading: false,
      errorRename: false,

      editedIndex: -1,
      editedEmail: '',
      editedId: 0,
      editedPercentage: null,

      editedPercentageTemp: 0,   
      itemTemp:[]

    };
  },

  created () {
    this.teamUserList = this.team_users     //usuarios do time
    this.teamStatus = this.team.status      //status do time
    this.t = this.translations.management   //traducoes
    console.log(this.t)
    if (this.team.nome == '') {
      this.teamName = this.t.team_account_insert_team_name
    }
    else{
      this.teamName = this.team.nome
    }
  },

  methods: {

    deleteItem (item) {
      this.sendToEndpoint(this.userToDelete,{
        'action': 'delete',
        'id_office_time': this.team.id,
        'id_office_time_usuario': this.userToDelete.id
      })
    },

    editItem (item) {
      this.resetDefaults();
      this.itemTemp = item;
      this.editedIndex = this.teamUserList.indexOf(item)
      this.editedPercentage = parseInt(item.percentual * 100);
      this.editedId = item.id
      this.editedPercentageTemp = this.editedPercentage
      this.editedEmail = item.email
      $('#modalEditTeamMember').modal('show');
    },

    saveItem () {
      if (this.checkForm()) {
        if (this.editedIndex > -1) {
          this.sendToEndpoint(this.itemTemp, {
            'action': 'update',
            'id_office_time': this.team.id,
            'id_office_time_usuario': this.editedId,
            'percentage': (this.editedPercentage/100)
          })
        } 
        else {
          this.sendToEndpoint(this.itemTemp, {
            'action': 'insert',
            'id_office_time': this.team.id,
            'email': this.editedEmail,
            'percentage': (this.editedPercentage/100)
          })
        }
      }
    },

    sendToEndpoint(item, data){
      let vm = this;
      vm.loading = true
      axios.post(this.handler_routes.member, data)
        .then(function (response) {
          if (response.data.status == 'success') {
            alertMsg('success', response.data.message)
            vm.teamStatus = response.data.status_team
            //reatividade no objeto teamUserList
            switch (data.action) {
              case 'delete':
                vm.teamUserList.splice(vm.teamUserList.indexOf(item), 1)
                $('#modalDeleteUser').modal("hide")
                break;
              case 'insert':
                vm.teamUserList.push(response.data.data)
                $('#modalEditTeamMember').modal("hide")
                break;
              case 'update':
                Object.assign(vm.teamUserList[vm.teamUserList.indexOf(item)], response.data.data)
                $('#modalEditTeamMember').modal("hide")
                break;
              default:
                console.log('Action error');
            }
          }
          else{
            alertMsg('error', response.data.message)
          }
        })
        .catch(function (error) {
          alertMsg('error', error)
        })
        .finally(() => (
          vm.loading = false
        ))
    },

    openModalDelete(userToDelete){
      this.userToDelete = userToDelete
      $('#modalDeleteUser').modal('show');
    },

    newMember(){
      this.resetDefaults();
      $('#modalEditTeamMember').modal('show');
    },

    renameTeam(){
      $('#modalRenameTeam').modal('show');
    },

    updateTeamName(){
      let vm = this;
      if (vm.newTeamName == '') {
        vm.errorRename = true;
        return;
      }

      vm.errorRename = false
      vm.buttonSaveTeamNameDisabled = true
      axios.post(vm.handler_routes.team, {
        'action': 'update_name', 
        'nome': vm.newTeamName,
        'id_time': vm.team.id,
      }).then(function (response) {
          if (response.data.status == 'success') {
            alertMsg('success', response.data.message)
            vm.teamName = vm.newTeamName;
            vm.newTeamName = '';
            $('#modalRenameTeam').modal('hide');
          }
          else{
            alertMsg('error', response.data.message)
            vm.buttonSaveTeamNameDisabled = false
          }
        })
        .catch(function (error) {
          vm.buttonSaveTeamNameDisabled = false
          alertMsg('error', error)
        })
    },    

    resetDefaults(){
      this.editedIndex = -1;
      this.editedPercentage = 0
      this.editedEmail = ''
      this.editedPercentageTemp = 0
      this.leaderNewPercentage = 0
      this.errorPercentage = false
      this.errorMail = false
    },

    //utilizado nos watchers
    validateForm(){
      this.comissionAvailable = (100 - this.totalDistributedPercentage) + this.editedPercentageTemp
      this.leaderNewPercentage = this.leaderComissionSimulation()
      //se a porcentagem não mudou, não precisa salvar
      if (this.editedPercentageTemp ==  this.editedPercentage) {
        this.buttonSaveDisabled = true;
      }
      else if(!this.editedEmail || this.editedEmail == '' ){
        this.buttonSaveDisabled = true;
      }
      else if (!this.editedPercentage){
        this.buttonSaveDisabled = true;
      }
      else{
        if (this.leaderNewPercentage == '-'){
          this.buttonSaveDisabled = true;
          this.errorPercentage = true;
        }
        else{
          this.buttonSaveDisabled = false;
          this.errorPercentage = false;
        }
      }
     },

     //utilizado no envio do formulário
     checkForm(){
      if (!this.validEmail(this.editedEmail)) {
        this.errorMail = true;
        return false;
      }
      return true;

     },

     validEmail: function (email) {
       var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
       return re.test(email);
     },

     //deve ser um método porque watch que chama o validate form é executado antes do computed
     leaderComissionSimulation(){
       let calc = (100 - this.totalDistributedPercentage - this.editedPercentage + this.editedPercentageTemp)
       if (calc < 0 || calc > 100 || this.editedPercentage < 1 || this.editedPercentage > 100) {
         return '-'
       }
       else{
         return calc+'%'
       }
     },

    /* carregamento de usuarios do time via GET
    loadData () {
      let vm = this;
      let url = "http://localhost/testes/vue/api_teamUserList/";
      axios.get(url).
        then(function(resposta){
          vm.users = resposta.data;        
          for (var i = resposta.data.length - 1; i >= 0; i--) {
            vm.totalDistributedPercentage += parseInt((resposta.data[i]['porcentagem']));
            vm.totalIntegrants++;
          }
          //sucesso
        }, function(erro){
          console.log(erro);
        });
      },
      */
   },

  watch: {
    editedIndex(){
      if (this.editedIndex == -1){
        this.fieldMailReadonly = false;
      }
      else{
        this.fieldMailReadonly = true;
      }
    },

    editedEmail(){
      this.validateForm();
    },

    editedPercentage(){
      this.validateForm();
    },
  },

  computed: {
    leaderComissionPercentage(){
       return (100 - this.totalDistributedPercentage);
    },

    totalPercent(){
      return this.totalDistributedPercentage = this.teamUserList.reduce((sum, teamUserList) =>{
        return sum + parseInt(teamUserList.percentual * 100)
      },0)
    },

    totalMembers(){
      return this.teamUserList.length + 1
    },
  },

  filters:{
    toFixed(value){
      return parseInt(value * 100);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../scss/team-account/style.scss';

//PROGRESS
.progressbar {
  background-color: #b880fe;
  border-radius: $radius;
  text-align: center;
  display: flex;
  line-height: 1.1;
  max-height: 15px;
}
.progressbar > .progressbar__label {
  background-color: var(--theme-color-accent);
  border-radius: $radius;
  vertical-align: middle;
  color: #fff;
  font-size: 11px;
  padding:2px;
  transition: 2s;
  span {
    color: inherit;
    font-size: inherit;
  }
}
.progressbar>.progressbar__label:last-child{
  background: #b880fe
}

.division-indicator__line{
  margin-left:-10px;
  margin-right:-10px;
  border-bottom: 1px solid #e7eaec;
  padding-top: 1rem;
}

.division-indicator{
  padding: 1rem 0;
}


</style>


// WEBPACK FOOTER //
// resources/office/js/components/team-account/management.vue